// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import axios from 'axios';
//axios
Vue.prototype.$axios = axios;

//global
import GLOBAL from '@/assets/js/global.js';
Vue.prototype.$global = GLOBAL;
Vue.prototype.$ajax_url_map = GLOBAL.ajax_url_map;

//vuescroll
import vuescroll from 'vuescroll';
Vue.use(vuescroll);

//loading
import loading from '@/components/loading'
Vue.component('loading', loading)

//vueSwiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App :mpl_list="mpl_list" :week_list="week_list" v-if="mpl_ready&week_ready"/>',
  data (){
    return {
      mpl_list : [],
      week_list : [],
      mpl_ready : false,
      week_ready : false,
    }
  },
  created (){

    let token = localStorage.getItem("token");

    var instance = axios.create();
    instance.defaults.timeout = 1000 * 20;
    instance.defaults.headers.post['Content-Type'] = 'application/json';
    instance.defaults.headers['withCredentials'] = true;
    axios.defaults.crossDomain=true;

    this.token = token;

    /* 请求拦截 */
    this.$axios.interceptors.request.use(
        config => {
            if(config.method === 'get'){
              config.params = {
                r: +new Date(), // 随机数
                ...config.params
              }              
            }     
            return config;
        },
        err => Promise.reject(err)
    );

    //请求返回拦截
    this.$axios.interceptors.response.use((response) => {
        return response.data;
    }, function (error) {
        return Promise.reject(error);
    });    
  },
  mounted (){
    this.get_public_list ()
    this.get_week_list ()
  },
  methods : {
    get_public_list (){
      this.$axios.get(this.$ajax_url_map.mpl_list)
      .then(
        res => {
          this.mpl_list = res;
          this.mpl_ready = true;
        },
        rej => {

        }
      );
    },
    get_week_list (){
      this.$axios.get(this.$ajax_url_map.week_list)
      .then(
        res => {
          this.week_list = res;
          this.week_ready = true;
        },
        rej => {

        }
      );
    },    
  },  
})



// WEBPACK FOOTER //
// ./src/main.js